// Örnek servis codiagno login
import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "v1/users";
const RESOURCE_NAME2 = "v1//admin";
const ADMIN_RESOURCE= "admin";

export default {
  getUsers(search = "",pageSize=15,page = 1,type="") {
    return axios.get(`${ADMIN_RESOURCE}/users`, {params:{Search:search,IsLight:false,pageSize:pageSize,page:page,Type:type}});
  },
  getUsersByType(type = "",pageSize=15,page=1,search=""){
    return axios.get(`${RESOURCE_NAME}`, {params:{Type:type,IsLight:false,pageSize:pageSize,page:page,Search:search}});
  },
  getUserDetails(id) {
    return axios.get(`${RESOURCE_NAME}?Id=${id}`,{params:{IsLight:false}});
  },
  getUserManager(id) {
    return axios.get(`${RESOURCE_NAME}/getmanagers?id=${id}`);
  },
  getSpecificUserManager(id) {
    return axios.get(`${RESOURCE_NAME2}/getusermanager?id=${id}`);
  },
  createUser(body) {
    return axios.post(`${RESOURCE_NAME}/create`, body);
  },
  searchUser(search = ""){
    return axios.get(`${RESOURCE_NAME}`, {params:{Search:search,IsLight:false}});
  },

  getCategories(search) {
    return axios.get(`${RESOURCE_NAME}`, {params:{Name:search}})
  },
  getBlockedUsers(search="",pageSize=15,page=1) {
    return axios.get(`admin/blockedusers`,{params:{Search:search,pageSize:pageSize,page:page}});
  },
  removeBlockedUser(body) {
    return axios.post(`admin/removeuserblock`,body);
  },
  updatePassword(body){
    return axios.post(`${RESOURCE_NAME}/changepassword`, body);
  },
  assignUserManager(body){
    return axios.post(`${RESOURCE_NAME2}/setmanager`, body);
  }

};
